module.exports = __webpack_public_path__ + "static/media/MTN.6bc066fb.png";